/**
 * StaffTab Component
 * Program staff information
 */

import React from 'react';
import styles from './TabStyles.module.css';

const StaffTab = ({ program }) => {
  const staff = program?.staff || [];

  return (
    <div className={styles.tabContainer}>
      <section className={styles.section}>
        <h3 className={styles.sectionTitle}>Staff</h3>
        
        <div className={styles.staffList}>
          {staff.length > 0 ? (
            staff.map((member, index) => (
              <div key={index} className={styles.staffItem}>
                <h4 className={styles.staffName}>{member.name}</h4>
                <p className={styles.staffInfo}>Role: {member.role}</p>
                <p className={styles.staffInfo}>Email: {member.email}</p>
                <p className={styles.staffInfo}>Phone: {member.cell}</p>
                {member.profileLink && (
                  <a 
                    href={member.profileLink} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className={styles.staffLink}
                  >
                    View Profile
                  </a>
                )}
              </div>
            ))
          ) : (
            <p className={styles.emptyMessage}>No staff information available.</p>
          )}
        </div>
      </section>
    </div>
  );
};

export default StaffTab;










